import { useAtomValue } from "jotai";
import { IServicesAtom, ProductsCollection } from "../stores/cms/productsStore";

export function useProductsCollection(): IServicesAtom {
  const products = useAtomValue(ProductsCollection);

  return products;
}
